import React from 'react';
import Footer from 'components/template/global-components/footer';
import WhatsAppButton from 'components/template/global-components/WhatsAppButton';
import Navbar from 'components/artectum/common/navbar-artectum';

const MainLayout = ({ children }) => {
    return (
        <div>
            <Navbar />
            {children}
            <Footer />
            <WhatsAppButton />
        </div>
    );
}

export default MainLayout;